<div class="modal-header">
    <h6 class="modal-title">{{ modalTitle }}</h6>
    <div class="spacer"></div>
    <button type="button" class="close" aria-label="Close" (click)="onClose()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
